<template>
  <div>
    <div class="sidebar">
      <div class="apply" @click="applyShow">
        <div class="img">
          <img src="../assets/sq.png" alt="" />
        </div>
        <div class="title">申请试用</div>
      </div>
      <div class="telephone">180-1765-0737</div>
    </div>
    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import ApplyDialog from "../components/applyDialog.vue";
export default {
  components: { ApplyDialog },
  data() {
    return {
      show: false
    };
  },
  methods: {
    applyShow() {
      this.show = true;
      // 禁止滚动
      this.noScroll()
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 50.3%;
  right: 0;
  z-index: 999;
  // width: 8.75rem;
  // height: 13.875rem;
}

.apply {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // height: 10.75rem;
  background-color: #ffffff;
  box-shadow: 0px 0px .375rem 0px rgba(0, 0, 0, 0.08);
  cursor: pointer;
  padding: 1.25rem;
}

.img {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 1rem;
  img{
    width: 5.5rem;
    height: 5.5rem;
  }
}

.telephone {
  // height: 3.125rem;
  background-color: #0e6eb8;
  text-align: center;
  // line-height: 3.125rem;
  font-size: .875rem;
  font-weight: bold;
  color: #ffffff;
  padding: 1rem;
}

.el-button:focus, .el-button:hover{
  color: #ffffff;
  border-color: none;
  background-color: none;
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
  .sidebar{
  .title{
    font-size: 12px !important;
  }
 .telephone{
  font-size: 10px !important;
 }
  }

}
</style>